const state = {
  filesData: {},
  filesActive: false,
};

const mutations = {
  CHANGE_FILES_CONTENT(state, filesObj) {
    state.filesData = filesObj;
  },
  CHANGE_FILES_ACTIVE(state, filesActive) {
    state.filesActive = filesActive;
  },
};

const actions = {
  someAsyncTask({ commit }) {
    // do something async
    commit('TEST');
  },
};

const getters = {
  filesData: (state) => {
    return state.filesData;
  },
  filesActive: (state) => {
    return state.filesActive;
  },
};
export default {
  state,
  mutations,
  actions,
  getters,
};
